export const favoriteBeersActionTypes = {
  ADD_FAVORITE_BEERS: "ADD_FAVORITE_BEERS",
  REMOVE_FAVORITE_BEERS: "REMOVE_FAVORITE_BEERS",
  UPDATE_FAVORITE_BEERS: "UPDATE_FAVORITE_BEERS",
  SET_FAVORITE_BEERS: "SET_FAVORITE_BEERS",
  FETCH_FAVORITE_BEERS_START: "FETCH_FAVORITE_BEERS_START",
  FETCH_FAVORITE_BEERS_SUCCESS: "FETCH_FAVORITE_BEERS_SUCCESS",
};
